"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = create;
var _view = require("../../types/view");
var _events = require("../../types/events");
var _social = require("../../types/social");
var _action_types = require("../../constants/action_types");
var _view2 = require("../view");
var _authenticate = require("./authenticate");
var _getIgnoreSocialDataForRegistration = require("./getIgnoreSocialDataForRegistration");
var _tracking = require("../../utils/tracking");
var _createUser = require("../../repositories/social-users/v1/create-user");
var _social2 = require("../../selectors/social");
var _source = require("../../selectors/source");
function create() {
  return (dispatch, getState, context) => {
    const {
      config,
      httpApi
    } = context;
    dispatch({
      type: _action_types.SOCIAL_CREATE_TYPE,
      status: _social.ECreateStatus.Loading
    });
    const state = getState();
    const email = (0, _social2.emailSelector)(state);
    const phone = (0, _social2.phoneSelector)(state);
    const source = (0, _source.sourceSelector)(state);
    const {
      social: {
        socialType,
        socialLoginId
      },
      agreement: {
        licenceAccepted,
        marketingSubscriptionAccepted
      },
      view
    } = state;
    if (!socialType || !socialLoginId) {
      throw new Error('Either socialType or socialLoginId is not present');
    }
    const ignoreSocialDataForRegistration = (0, _getIgnoreSocialDataForRegistration.getIgnoreSocialDataForRegistration)(socialType, config);
    return (0, _createUser.fetchCreateUser)({
      httpApi,
      parameters: {
        socialLoginId,
        email,
        phone,
        ignoreSocialDataForRegistration,
        isAcceptLicence: licenceAccepted,
        hasMarketingSubscriptions: marketingSubscriptionAccepted
      },
      config: {
        requestConfig: {
          headers: [['Content-Type', 'application/json']],
          withCredentials: true
        }
      }
    }).then(response => {
      if (response.statusCode === 200) {
        const socialLoginId = response.response.socialLoginId;
        const email = response.response.email || '';
        const token = response.response.token || '';
        dispatch({
          type: _action_types.SOCIAL_CREATE_TYPE,
          status: _social.ECreateStatus.Succeed
        });
        (0, _tracking.trackSocialCreateCreateClick)({
          source
        });
        dispatch((0, _authenticate.authenticate)({
          socialType,
          socialLoginId,
          email,
          token,
          userCreated: true,
          source
        }));
        return;
      } else if (response.statusCode === 400 && response.response.errors.length > 0 && response.response.errors.some(error => error.code === 'existed_email')) {
        dispatch({
          type: _action_types.SOCIAL_CREATE_TYPE,
          status: _social.ECreateStatus.Failed,
          errorType: _social.ECreateError.MergeRequired,
          error: response.response.message,
          email
        });
        dispatch((0, _view2.changeView)(_view.EActiveView.SocialMerge, {
          prevView: _view.EActiveView.SocialCreate
        }));
        context.emitter.emit(_events.EEventType.SocialAuthenticateEmailTaken, {
          type: socialType
        });
        return;
      } else if (response.statusCode === 400 && response.response.errors.length > 0 && response.response.errors.some(error => error.code === 'LicenceDoesNotAccepted')) {
        dispatch({
          type: _action_types.SOCIAL_CREATE_TYPE,
          status: _social.ECreateStatus.Failed,
          errorType: _social.ECreateError.LicenceNotAccepted,
          error: response.response.message
        });
        dispatch((0, _view2.changeView)(_view.EActiveView.Agreement, {
          prevView: view.active,
          prevData: view.data
        }));
        return;
      } else if (response.statusCode === 400 && response.response.errors.length > 0 && response.response.errors.some(error => error.code === 'blockedRegistrationForSocialNetwork')) {
        dispatch({
          type: _action_types.SOCIAL_CREATE_TYPE,
          status: _social.ECreateStatus.Failed,
          errorType: _social.ECreateError.BlockedRegistrationForSocialNetwork,
          error: response.response.message
        });
        dispatch((0, _view2.changeView)(_view.EActiveView.SocialCreate));
        return;
      }
      dispatch({
        type: _action_types.SOCIAL_CREATE_TYPE,
        status: _social.ECreateStatus.Failed,
        errorType: _social.ECreateError.Common,
        error: response.response.message
      });
      dispatch((0, _view2.changeView)(_view.EActiveView.SocialCreate));
    }).catch(error => {
      context.logger.error(error, {
        domain: 'auth-widget.api.socialCreate',
        socialType
      });
      dispatch({
        status: _social.ECreateStatus.Failed,
        type: _action_types.SOCIAL_CREATE_TYPE,
        errorType: _social.ECreateError.Unexpected,
        error: 'Произошла непредвиденная ошибка'
      });
      dispatch((0, _view2.changeView)(_view.EActiveView.SocialCreate));
    });
  };
}